export const ManualLog = {
    id: 1,
    name: 'Manual Log',
    value: 'Manual Log',
};
export const StatusChange = {
    id: 2,
    name: 'Status Change',
    value: 'Status Change',
};
export const TextToAudio = {
    id: 3,
    name: 'Text to Audio',
    value: 'Text to Audio',
};
export const ContentUpdate = {
    id: 4,
    name: 'Content Update',
    value: 'Content Update',
};
export const ContentMovementHistory = {
    id: 5,
    name: 'Content Movement History',
    value: 'Content Movement History',
};
export const ItemUpdate = {
    id: 7,
    name: 'Item Update',
    value: 'Item Update',
};
const Basic = [
    ManualLog,
    StatusChange,
    TextToAudio,
    ContentUpdate,
    ContentMovementHistory,
];
const ItemLogTypes = [...Basic, ItemUpdate];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const ById = ItemLogTypes.reduce((hash, type) => {
    hash[type.id] = type;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    ItemLogTypes,
    ById,
    BasicByValue,
    BasicProps,
    ManualLog,
    StatusChange,
    TextToAudio,
    ContentMovementHistory,
    ItemUpdate,
};
